import { Modal } from '@mantine/core';
import { ReactNode } from 'react';

interface Props {
	isOpen: boolean;
	onClose: VoidFunction;
	children: ReactNode;
	title: string;
	/** Stretch the body over the modal's full height so its content can pin a footer to the bottom. */
	fillHeight?: boolean;
}

export const DocumentsModal = (props: Props) => {
	const fillHeightStyles = props.fillHeight
		? { display: 'flex', flexDirection: 'column' as const }
		: {};

	return (
		<Modal
			id="docs-modal"
			title={props.title}
			centered={true}
			size="auto"
			opened={props.isOpen}
			onClose={props.onClose}
			closeButtonProps={{
				iconSize: 20,
				size: 'sm',
			}}
			styles={{
				inner: {
					paddingLeft: '3.75rem!important',
					paddingRight: '3.75rem!important',
				},
				content: {
					width: '100%',
					maxWidth: '100%',
					height: '100%',
					maxHeight: '100%',
					...fillHeightStyles,
				},
				body: {
					padding: '1rem',
					...fillHeightStyles,
					...(props.fillHeight && { flex: 1, minHeight: 0 }),
				},
				header: {
					paddingTop: '1rem',
					paddingRight: '1rem',
					paddingLeft: '1rem',
					marginBottom: '1rem',
					paddingBottom: '0rem',
				},
			}}
			overlayProps={{ opacity: 0.6, blur: 3 }}
		>
			{props.children}
		</Modal>
	);
};
